import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card"; // Ensure this path is correct
import { FaArrowRightLong } from "react-icons/fa6";
import { Skeleton } from "@/components/ui/skeleton"; // Add skeleton import

function ProjectCards(props) {
  const [hover, setHover] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <Link to={props.active ? props.demoLink : "#"} className="block h-full">
      <Card
        className="project-card-view relative flex flex-col justify-between h-full shadow-none p-3 md:p-4 lg:p-6 group rounded-lg" // Added rounded-lg explicitly, though shadcn card usually has it.
        onClick={() => {
          if (props.active && window.analytics) {
            window.analytics.track("Project Opened", {
              project: props.title,
            });
          }
        }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        {/* Image */}
        <CardHeader className="p-0 relative w-full h-40 md:h-48 lg:h-56 xl:h-64 flex justify-center items-center overflow-hidden rounded-lg">
          {!imageLoaded && (
            <Skeleton className="absolute inset-0 w-full h-full rounded-lg" />
          )}
          <img
            src={props.imgPath}
            alt="card-img"
            className={`rounded-lg object-cover w-full h-full transition-all duration-500 ease-in-out group-hover:scale-105 ${
              !imageLoaded ? 'opacity-0' : ''
            }`}
            style={{
              opacity: hover ? 0.5 : imageLoaded ? 1 : 0,
            }}
            onLoad={() => setImageLoaded(true)}
          />
        </CardHeader>

        {/* Title visible only on small screens and hidden by default on md+ (original logic) */}
        <CardTitle className="mt-2 text-sm sm:text-base md:text-lg font-light mb-2 text-gray-800 sm:hidden">
          {props.title}
        </CardTitle>

        {/* Text content overlay */}
        <CardContent
          className="absolute inset-0 flex flex-col justify-center items-center z-10 p-0 rounded-lg" // p-0 to override default CardContent padding. rounded-lg to match parent Card.
          style={{
            backgroundColor: hover ? "rgba(0, 0, 0, 0.9)" : "transparent",
            transition: "background-color 0.5s ease-in-out",
          }}
        >
          <CardTitle className="text-center text-sm sm:text-base md:text-lg lg:text-xl font-semibold mb-2 text-transparent transition-all duration-500 ease-in-out group-hover:text-white">
            {props.title}
          </CardTitle>
          <div
            className="text-xs sm:text-sm md:text-base lg:text-md font-medium text-transparent transition-all duration-500 ease-in-out group-hover:text-white px-2.5 text-center leading-snug" // Replaced inline padding/textAlign/lineHeight
            // max-w-sm could be added here if text tends to be very wide
          >
            {props.description}
          </div>

          {/* Learn More Section */}
          <div
            className="absolute bottom-10 right-10 flex items-center mt-4 text-sm sm:text-base md:text-md lg:text-lg font-medium text-transparent transition-all duration-800 ease-in-out group-hover:text-white"
            // Original styling for padding, textAlign, lineHeight on this div was removed as they are not needed for an absolutely positioned flex container or are better handled by children.
          >
            <span className="mr-1 text-sm sm:text-base md:text-md lg:text-lg font-light">
              See More
            </span>
            <FaArrowRightLong
              className="text-white text-base md:text-lg transition-transform duration-500 ease-in-out transform group-hover:translate-x-4"
              // Inline style for transition was redundant with Tailwind classes
            />
          </div>
        </CardContent>
      </Card>
    </Link>
  );
  
}

export default ProjectCards;